import React from "react";

import { ButtonGroup, Divider } from "@mui/material";

import Button from "@src/multiCustodian/components/MUI/Button/Button";

interface ToggleOption {
  key: string;
  text: string;
  action: () => void;
}

interface Props {
  selected: string;
  options: ToggleOption[];
}

const SegmentedButton: React.FC<Props> = ({ selected, options }) => {
  return (
    <ButtonGroup
      sx={{
        backgroundColor: "var(--surfaceLow)",
        "& .MuiButton-root": {
          minWidth: "120px",
        },
      }}
    >
      {options.map((option, index) => (
        <React.Fragment key={option.key}>
          <Button
            variant={selected === option.key ? "contained" : "text"}
            buttonType="primary"
            text={option.text}
            onClick={option.action}
            sx={{ minWidth: "106px" }}
          />
          {index === options.length - 1 ? null : (
            <Divider
              orientation="vertical"
              flexItem
              variant="middle"
              sx={{
                visibility:
                  option.key === selected || options[index + 1].key === selected
                    ? "hidden"
                    : "visible",
              }}
            />
          )}
        </React.Fragment>
      ))}
    </ButtonGroup>
  );
};

export default SegmentedButton;
